import React, { Component } from "react";
import $ from "jquery";


class UnavailableForm extends Component {
    constructor(props) {
        super(props)
        this.state =
        {
            displayErrors: false,
            channelFormData: {
                HallmarkChannel:false,
                HallmarkChannelHD:false,
                HallmarkMoviesAndMysteries:false,
                HallmarkMoviesAndMysteriesHD:false,
                HallmarkDrama:false
            }
        }
        
        this.submitForm = this.submitForm.bind(this);
        this.success = this.success.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        
        this.setState({channelFormData: {...this.state.channelFormData, [name]: value}
        });

      }

    submitForm(event) {
        event.preventDefault();
        if (!event.currentTarget.checkValidity()) {
            this.setState({ displayErrors: true });
            return;
        }
        this.setState({ displayErrors: false });
  
        $.ajax({
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            type: "POST",
            url: "http://channellocator.cminternalcontrol.com/api/requests",
            data: JSON.stringify(this.state.channelFormData),
            dataType: 'json',
            success: this.success,
            processData: false
        });
    }

    success(data) {
        window.location.href = "#/submission-confirmation";
    }

    render() {
        const { displayErrors } = this.state;
        return (
            <div className="container">
                <div className="col-md-12 unavailable-form-text">
                    <h3>If Hallmark Channel, Hallmark Mystery, or Hallmark Family are not available in your area, please let us know by filling out the form below. </h3>
                </div>
                <form noValidate onSubmit={this.submitForm} className={displayErrors ? 'displayErrors' : ''}>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label className="inp">
                                <input name="FirstName" type="text" id="" placeholder="&nbsp;" required onChange={this.handleInputChange} value={this.state.value}/>
                                <span className="label">First Name</span>
                                <span className="border"></span>
                            </label>
                        </div>
                        <div className="form-group col-md-6">
                            <label className="inp">
                                <input name="LastName" type="text" id="" placeholder="&nbsp;" required onChange={this.handleInputChange} value={this.state.value}/>
                                <span className="label">Last Name</span>
                                <span className="border"></span>
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-12">
                            <label className="inp">
                                <input name="Address" type="text" id="" placeholder="&nbsp;" required onChange={this.handleInputChange} value={this.state.value}/>
                                <span className="label">Address</span>
                                <span className="border"></span>
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label className="inp">
                                <input name="City" type="text" id="" placeholder="&nbsp;" required onChange={this.handleInputChange} value={this.state.value}/>
                                <span className="label">City</span>
                                <span className="border"></span>
                            </label>
                        </div>
                        <div className="form-group col-md-4">
                            <label className="inp">
                                <input name="State" type="text" id="" placeholder="&nbsp;" required onChange={this.handleInputChange} value={this.state.value}/>
                                <span className="label">State</span>
                                <span className="border"></span>
                            </label>
                        </div>
                        <div className="form-group col-md-2">
                            <label className="inp">
                                <input name="Zip" type="text" id="" placeholder="&nbsp;" required onChange={this.handleInputChange} value={this.state.value}/>
                                <span className="label">Zip</span>
                                <span className="border"></span>
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-12">
                            <label className="inp">
                                <input name="Email" type="email" id="" placeholder="&nbsp;" required onChange={this.handleInputChange} value={this.state.value} />
                                <span className="label">Email</span>
                                <span className="border"></span>
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-12">
                            <label className="inp">
                                <input name="CableProvider" type="text" id="" placeholder="&nbsp;" required onChange={this.handleInputChange} value={this.state.value}/>
                                <span className="label">Cable Provider</span>
                                <span className="border"></span>
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group">
                            <label className="col-sm-4 control-label">Service(s) requested (choose at least 1):</label>
                            <div className="col-sm-8">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <label className="radio-inline"> <input type="checkbox" name="HallmarkChannel" checked={this.state.HallmarkChannel} onChange={this.handleInputChange} /> Hallmark Channel </label>
                                    </div>
                                    <div className="col-sm-4">
                                        <label className="radio-inline"> <input type="checkbox" name="HallmarkMoviesAndMysteries" checked={this.state.HallmarkMoviesAndMysteries} onChange={this.handleInputChange} /> Hallmark Mystery </label>
                                    </div>
                                    <div className="col-sm-4">
                                        <label className="radio-inline"> <input type="checkbox" name="HallmarkDrama" checked={this.state.HallmarkDrama} onChange={this.handleInputChange} /> Hallmark Family </label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <label className="radio-inline"> <input type="checkbox" name="HallmarkChannelHD" checked={this.state.HallmarkChannelHD} onChange={this.handleInputChange} /> Hallmark Channel HD</label>
                                    </div>
                                    <div className="col-sm-5">
                                        <label className="radio-inline"> <input type="checkbox" name="HallmarkMoviesAndMysteriesHD" checked={this.state.HallmarkMoviesAndMysteriesHD} onChange={this.handleInputChange} /> Hallmark Mystery HD</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='inputCheckbox'>
                        <p>
                        <input name="EmailAgree" type="checkbox" checked={this.state.EmailAgree} onChange={this.handleInputChange} value={this.state.value}/> By checking this box, I acknowledge that Hallmark Media and its affiliated companies can email me about special offers and promotions and newsletters, and that I agree to Hallmark Channel's 
                        <a href="https://www.hallmarkchannel.com/privacy-policy" target="_blank" rel="noopener noreferrer"> Privacy Policy</a> and 
                        <a href="https://www.hallmarkchannel.com/crown-media-family-networks-terms-of-use" target="_blank" rel="noopener noreferrer"> Terms of Use</a>.
                        </p>
                    </div>
                    <div>
                        <button type="submit" className="unavailable-form-submit">Submit</button>
                    </div>
                </form>
            </div>
        );
    }
}

export default UnavailableForm;


// WEBPACK FOOTER //
// ./src/components/UnavailableForm.js